import type { ReactNode } from 'react';
import { Flex, Typography } from 'antd';
import { coresDaOferta } from '@titularis/ui';

/**
 * O cabeçalho de uma tela de módulo: quem é, o que é, e o estado à direita.
 *
 * É a casca que o Enac e a Legislação Comentada dividem - título, uma linha de
 * resumo, um lugar para o estado do lado direito e o fio que fecha o bloco. O
 * que muda entre as telas é o conteúdo do lado direito; a forma é a mesma, e
 * é por isso que ela mora aqui e não em cada página.
 *
 * **O fio é a assinatura do módulo**: sai da cor dele e morre no transparente,
 * o que dá cara própria ao Enac (verde), à 1ª fase (azul), à 2ª (marrom) e à
 * Legislação (ameixa) sem escrever nada diferente em cada tela. Para quem
 * comprou, ele vira o degradê dos três produtos - a mesma assinatura da chamada
 * da oferta e do selo do perfil.
 */
export function CabecalhoDaTela({
  titulo,
  resumo,
  acento,
  premium,
  direita,
}: {
  titulo: string;
  /** Uma linha sobre o que o módulo é. */
  resumo?: string;
  /** A cor do módulo, crua - ver o porquê em `CabecalhoDoModulo`. */
  acento: string;
  /** O fio ganha o degradê dos produtos quando o módulo já foi comprado. */
  premium?: boolean;
  /** O estado do módulo: a cota, o prazo do acesso, o que a tela tiver. */
  direita?: ReactNode;
}) {
  return (
    <Flex vertical gap={4} style={{ width: '100%' }}>
      <Flex align="flex-start" justify="space-between" gap={16} wrap>
        <Flex vertical gap={4} style={{ minWidth: 260 }}>
          <Typography.Title level={3} style={{ margin: 0 }}>
            {titulo}
          </Typography.Title>
          {resumo ? (
            <Typography.Text type="secondary" style={{ maxWidth: 620 }}>
              {resumo}
            </Typography.Text>
          ) : null}
        </Flex>

        {direita}
      </Flex>

      <div
        aria-hidden
        style={{
          height: 2,
          marginTop: 14,
          borderRadius: 2,
          background: premium
            ? `linear-gradient(90deg, ${coresDaOferta.join(', ')}, transparent)`
            : `linear-gradient(90deg, ${acento}, transparent)`,
        }}
      />
    </Flex>
  );
}
